import classnames from 'classnames';
import React from 'react';

export default function BaseIcon(props) {
  let { className, viewBox, title: titleText, titleId, children } = props;
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      viewBox={viewBox || '0 0 19 21'}
      className={classnames('iconContainer', className)}
      role="img"
      aria-labelledby={titleId}
    >
      <title id={titleId}>{titleText}</title>
      {children}
    </svg>
  );
}
